import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Method } from './components/Method';
import { Contents } from './components/Contents';
import { Author } from './components/Author';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { LegalFooter } from './components/LegalFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31agpgrwy8ll1">
      <noscript data-id="element-1" data-mp="31ctaxf1x1e2u">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="2wk06ksad07ra" />
      </noscript>
      <Hero data-id="element-3" data-mp="23w4g45bdvc2y" />
      <main data-id="element-4" data-mp="23u9q4cl98ts0">
        <Problem data-id="element-5" data-mp="23utby4e102bb" />
        <Method data-id="element-6" data-mp="23t8iki3g6pf1" />
        <Contents data-id="element-7" data-mp="3ijxq4swlw4ky" />
        <Author data-id="element-8" data-mp="3ikh829m9asyz" />
        <Testimonials data-id="element-9" data-mp="3iiweam7rne26" />
        <Offer data-id="element-10" data-mp="3ijfunyhrpue3" />
        <Faq data-id="element-11" data-mp="3ihv0i9zd8dgr" />
      </main>
      <LegalFooter data-id="element-12" data-mp="3mlavz2zp87rv" />
    </div>;
}